// extracted by mini-css-extract-plugin
export default {"header":"GalleryHeader_header__o6F+Q","detailsNavigation":"GalleryHeader_detailsNavigation__TCSUu","patientInfo":"GalleryHeader_patientInfo__IuGe2"};